import { useMutation } from "@tanstack/react-query";

import { CreateMfaChallengeResponse } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";

export const useCreateMfaChallenge = () => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useMutation({
    mutationFn: (): Promise<CreateMfaChallengeResponse> =>
      fetch(ENDPOINTS.mfa.challenge, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
      }).then(handleResponse),
    onError: (error: string) => {
      displayErrorToast(error);
    },
  });
};
